// 秒杀详情页
export default {
  routes: [
    {
      path: '/secondKillDetail',
      name: 'secondKillDetail',
      meta: {
        desc: '秒杀详情页'
      },
      component: () =>
        import(/* webpackChunkName: "secondKillDetail" */ '../views/secondKillDetail/index.vue')
    }
  ]
}
